import * as Vuex from 'vuex';
export const store = Vuex.createStore({
    state() {
        return {
            spinning: false,
        };
    },
    mutations: {
        setSpinner(state, spinning) {
            state.spinning = spinning;
        },
    },
});
